module.exports = __webpack_public_path__ + "static/assets/c7942c007d78f82c6fc954305fb97df4.png";